import { matchPath, useLocation } from 'react-router-dom';

const getIsActiveRoute = (path: string | string[], end = false) => {
    const location = useLocation();
    const paths = Array.isArray(path) ? path : [path];
    return paths.some((path) => Boolean(matchPath({ path, end }, location.pathname)));
};

export default getIsActiveRoute;
